import { createTanstackEndpoint } from "../utils/create-endpoint"
import { endpoints } from "./endpoints"

const endpoint = endpoints.public.formStructureShares

export const createFormStructureShare = createTanstackEndpoint(endpoint, "POST")
